export type CurrencyType = {
  code: string
  name: string
  country: string
  icon: string
}

export const currencies: CurrencyType[] = [
  {
    code: 'MXN',
    name: 'Mexican Peso',
    country: 'Mexico',
    icon: '/assets/currencies/mx.svg',
  },
  {
    code: 'USD',
    name: 'United States Dollar',
    country: 'United States',
    icon: '/assets/currencies/us.svg',
  },
  {
    code: 'EUR',
    name: 'Euro',
    country: 'European Union',
    icon: '/assets/currencies/eu.svg',
  },
  {
    code: 'GBP',
    name: 'British Pound',
    country: 'United Kingdom',
    icon: '/assets/currencies/gb.svg',
  },
  {
    code: 'CAD',
    name: 'Canadian Dollar',
    country: 'Canada',
    icon: '/assets/currencies/ca.svg',
  },
  {
    code: 'JPY',
    name: 'Japanese Yen',
    country: 'Japan',
    icon: '/assets/currencies/jp.svg',
  },
]
